import BasicView from './BasicView';

export default BasicView;
